export default __webpack_public_path__ + "static/media/ic_menu_collapse.66ccb394.svg";